import { render, staticRenderFns } from "./box17.vue?vue&type=template&id=212ca692&scoped=true&"
import script from "./box17.vue?vue&type=script&lang=js&"
export * from "./box17.vue?vue&type=script&lang=js&"
import style0 from "./box17.vue?vue&type=style&index=0&id=212ca692&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212ca692",
  null
  
)

export default component.exports